import { useTranslation } from 'react-i18next';
import { Image, ImageBackground, StyleSheet, Text, View } from 'react-native';

import {
	BGCurrentDayFrame,
	BGRegularDayFrame,
	BonusGamesModalDays,
	VipBadgeFramePng,
} from '../../../../assets';
import { DayCount } from './utils';

export interface BGDayProps {
	day: DayCount;
	bonus: number;
	vipBonus?: number;
	currentDay?: DayCount;
	isVip?: boolean;
}

function BGDay({ day, bonus, vipBonus, currentDay, isVip }: BGDayProps) {
	const { t } = useTranslation();
	const isCurrent = currentDay != null && day === currentDay;
	const isFutureOrCurrent = currentDay !== undefined && day <= currentDay;

	return (
		<View style={{ flex: isCurrent ? 1.1 : 1 }}>
			<View style={styles.fullWidth}>
				<ImageBackground
					source={isCurrent ? BGCurrentDayFrame : BGRegularDayFrame}
					style={[
						styles.dayFrame,
						{
							aspectRatio: isCurrent ? 1.119 : 1.088,
							paddingBottom: isVip ? 10 : 0,
							paddingTop: 10,
						},
					]}
					imageStyle={styles.dayFrameImage}
				>
					<View>
						<Text style={styles.dayLabel}>
							{t('T_SITE_MODAL_BONUS_DAY')} {day}
						</Text>
					</View>
					<Image
						source={BonusGamesModalDays[day]}
						style={[
							styles.dayIcon,
							{
								opacity: isFutureOrCurrent ? 1 : 0.4,
								height: '58%',
								marginBottom: -18,
							},
						]}
					/>
					<Text
						style={[
							styles.bonusAmount,
							{
								color: isFutureOrCurrent ? '#e9bf43' : '#d1d1d1',
								fontSize: 24,
								lineHeight: 26,
							},
						]}
					>
						{bonus}
					</Text>
					<View style={styles.vipRowSlot}>
						{isVip ? (
							<View style={styles.vipRow}>
								<Image source={VipBadgeFramePng} style={styles.vipBadge} />
								<Text
									style={[
										styles.vipBonusText,
										{
											color: isFutureOrCurrent ? '#e9bf43' : '#d1d1d1',
											fontSize: 16,
											lineHeight: 16,
										},
									]}
								>
									+{vipBonus}
								</Text>
							</View>
						) : null}
					</View>
				</ImageBackground>
			</View>
		</View>
	);
}

const styles = StyleSheet.create({
	fullWidth: {
		width: '100%',
	},
	dayFrame: {
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: 10,
	},
	dayFrameImage: {
		resizeMode: 'stretch',
	},
	dayLabel: {
		fontWeight: 'bold',
		color: '#fff',
		paddingBottom: 6,
	},
	dayIcon: {
		height: '58%',
		aspectRatio: 1,
		marginBottom: -18,
		marginRight: 2,
	},
	bonusAmount: {
		fontSize: 24,
		fontWeight: 'bold',
		lineHeight: 26,
		marginBottom: 2,
	},
	vipRowSlot: {
		height: 16,
		justifyContent: 'center',
	},
	vipRow: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	vipBadge: {
		width: 16,
		height: 16,
		marginRight: 4,
	},
	vipBonusText: {
		fontSize: 16,
		fontWeight: 'bold',
		lineHeight: 16,
	},
});

export default BGDay;
